import { render, staticRenderFns } from "./RequestSIFDE.vue?vue&type=template&id=24e64987&lang=true"
import script from "./RequestSIFDE.vue?vue&type=script&lang=js"
export * from "./RequestSIFDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports